import styled from 'styled-components';

export const NegativeMarginWrapper = styled.div`
  margin: -0.8rem -1rem 0.8rem;
`;
